import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, Divider, Paper, Typography } from '@mui/material'
import ROUTES from '../../../routesConfig'
import MarketingPageLayout from './MarketingPageLayout'

const VenuesPage = () => {
  return (
    <MarketingPageLayout>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
            Anear for Bars &amp; Venues
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.65, color: 'rgba(230,233,239,0.9)' }}>
            Anear helps venues turn a crowd into a community. With live, phone-based games and group experiences, strangers become friends, guests stay
            longer, interact more, and come back for the next event.
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            bgcolor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 2,
            p: 2.5,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1.5 }}>
            Great for
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Trivia nights
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Music or DJ breaks
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Live polls &amp; voting
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Casual group games
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Hosted events &amp; emcees
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 1.25, color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Guests scan a QR code displayed on a screen and play along on their phones—no downloads required. The QR code spreads naturally as people share it with others nearby, building the experience organically.
          </Typography>
        </Paper>

        <Box>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
            Why Venues Love Anear
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - No special hardware
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Works with TVs, tablets, or phones
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Easy for staff or hosts to run
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Encourages repeat visits
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Keeps guests engaged without isolating them
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 1.25, color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Anear adds energy to the room without competing with it.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
            Built for Live Hosts
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Anear supports hosted experiences where an emcee, bartender, or event lead controls the flow—perfect for trivia,
            contests, or audience participation.
          </Typography>
        </Box>

        <Box>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 1.5 }} />
          <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
            <Button component={RouterLink} to={ROUTES.APPS} variant="contained" color="primary" sx={{ fontWeight: 700 }}>
              Explore apps
            </Button>
            <Button
              component={RouterLink}
              to={ROUTES.HOW_IT_WORKS}
              variant="outlined"
              sx={{ fontWeight: 700, color: '#E6E9EF', borderColor: 'rgba(255,255,255,0.25)' }}
            >
              How it works
            </Button>
          </Box>
        </Box>
      </Box>
    </MarketingPageLayout>
  )
}

export default VenuesPage


